export const ADD_INGREDIENT           = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT        = 'REMOVE_INGREDIENT';
export const SET_INGREDIENTS          = 'SET_INGREDIENTS';
export const FETCH_INGREDIENTS_FAILED = 'FETCH_INGREDIENTS_FAILED';
export const BUY_BURGER_SUCCESS       = 'BUY_BURGER_SUCCESS';
export const BUY_BURGER_FAIL          = 'BUY_BURGER_FAIL';
export const BUY_BURGER_START         = 'BUY_BURGER_START';
export const BUY_INIT                 = 'BUY_INIT';
export const FETCH_ORDERS_START       = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS     = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL        = 'FETCH_ORDERS_FAIL';
export const AUTH_START               = 'AUTH_START';
export const AUTH_SUCCESS             = 'AUTH_SUCCESS';
export const AUTH_FAIL                = 'AUTH_FAIL';
export const AUTH_LOGOUT              = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH   = 'SET_AUTH_REDIRECT_PATH';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js